/**
 * Fiskal Cloud Selfcare API
 * # Overview  ## TSS pre-initialization Pre-initializes TSS with following options: * creating cloud TSS (with CSP account) for ERS that are not assigned to any TSS * creating cloud TSS (with CSP account) for BP that doesn\'t have any TSS * activation of inactive TSS and creation of CSP account 
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { TssPreInitializationDTO } from '../model/models';
import { TssPreInitializationModeDTO } from '../model/models';
import { TssPreInitializationRequestDTO } from '../model/models';
import { TssPreInitializationStatusDTO } from '../model/models';
import { TssPreInitializationsResponseDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface CreateTssPreInitializationRequestParams {
    tssPreInitializationRequestDTO?: TssPreInitializationRequestDTO;
}

export class ClsCreateTssPreInitializationRequestParams {
    tssPreInitializationRequestDTO?: TssPreInitializationRequestDTO = undefined;
}

export interface GetTssPreInitializationRequestParams {
    tssPreinitializationId: string;
}

export class ClsGetTssPreInitializationRequestParams {
    tssPreinitializationId: string = undefined;
}

export interface ListTssPreInitializationsRequestParams {
    mode?: Array<TssPreInitializationModeDTO>;
    status?: Array<TssPreInitializationStatusDTO>;
    pageNumber?: number;
    pageSize?: number;
    sort?: string;
}

export class ClsListTssPreInitializationsRequestParams {
    mode?: Array<TssPreInitializationModeDTO> = undefined;
    status?: Array<TssPreInitializationStatusDTO> = undefined;
    pageNumber?: number = undefined;
    pageSize?: number = undefined;
    sort?: string = undefined;
}


export interface PreInitApiClientInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Pre-initializes TSS
     * 
* @param requestParameters
     */
    createTssPreInitialization(requestParameters: CreateTssPreInitializationRequestParams, extraHttpRequestParams?: any): Observable<TssPreInitializationDTO>;

    /**
     * Get information about pre-initialization process
     * 
* @param requestParameters
     */
    getTssPreInitialization(requestParameters: GetTssPreInitializationRequestParams, extraHttpRequestParams?: any): Observable<TssPreInitializationDTO>;

    /**
     * Lists TSS pre-initializations
     * 
* @param requestParameters
     */
    listTssPreInitializations(requestParameters: ListTssPreInitializationsRequestParams, extraHttpRequestParams?: any): Observable<TssPreInitializationsResponseDTO>;

}
